export class HomeData {
  public static FTETimeSpent: Map<
    string,
    { id?: number; text?: string; percentage: number }
  > = new Map<string, { id?: number; text?: string; percentage: number }>();
  public Currency = ['USD', 'CAD', 'EUR', 'GBP'];

  public Init() {
    HomeData.FTETimeSpent.set('pct_planningEval', {
      id: 1,
      text: 'Support Tickets',
      percentage: 20,
    })
      .set('pct_monitoring', {
        id: 2,
        text: 'Planning / Evaluations',
        percentage: 15,
      })
      .set('pct_applicationOptimization', {
        id: 3,
        text: 'Application Optimization',
        percentage: 20,
      })
      .set('pct_securityEomp', {
        id: 4,
        text: 'Security / Compliance',
        percentage: 10,
      })
      .set('pct_userAccess', { id: 5, text: 'User Access', percentage: 10 })
      .set('pct_dataProtection', {
        id: 6,
        text: 'Data Protection',
        percentage: 15,
      })
      .set('pct_newInstalls', { id: 7, text: 'New Installs', percentage: 10 });
  }

  public FTETimeSpentValuesSum(
    sValue: number,
    slider: string,
  ): [number, number, number] {
    let totalExcludingCurrent = 0;

    // Calculate total excluding the current slider
    HomeData.FTETimeSpent.forEach((value, key: string) => {
      if (key !== slider) {
        totalExcludingCurrent += value.percentage;
      }
    });

    // Check if total exceeds 100 when adding sValue
    if (totalExcludingCurrent + sValue > 100) {
      // Adjust sValue so that total becomes 100
      sValue = 100 - totalExcludingCurrent;
    }

    // Update the HomeData.FTETimeSpent with the new or adjusted sValue
    HomeData.FTETimeSpent.set(slider, {
      ...HomeData.FTETimeSpent.get(slider),
      percentage: sValue,
    });

    // The newSum is either the original totalExcludingCurrent + sValue, or 100 if it was adjusted
    const newSum = totalExcludingCurrent + sValue;

    return [sValue, newSum, totalExcludingCurrent];
  }

  public setDefault() {
    HomeData.FTETimeSpent.set('pct_planningEval', {
      ...HomeData.FTETimeSpent.get('pct_planningEval'),
      percentage: 20,
    })
      .set('pct_monitoring', {
        ...HomeData.FTETimeSpent.get('pct_monitoring'),
        percentage: 15,
      })
      .set('pct_applicationOptimization', {
        ...HomeData.FTETimeSpent.get('pct_applicationOptimization'),
        percentage: 20,
      })
      .set('pct_securityEomp', {
        ...HomeData.FTETimeSpent.get('pct_securityEomp'),
        percentage: 10,
      })
      .set('pct_userAccess', {
        ...HomeData.FTETimeSpent.get('pct_userAccess'),
        percentage: 10,
      })
      .set('pct_dataProtection', {
        ...HomeData.FTETimeSpent.get('pct_dataProtection'),
        percentage: 15,
      })
      .set('pct_newInstalls', {
        ...HomeData.FTETimeSpent.get('pct_newInstalls'),
        percentage: 10,
      });
  }

  public MaturityType = [
    { id: 0, text: 'Select One', number: 0 },
    { id: 1, text: 'Basic', number: 3500 },
    { id: 2, text: 'Defined', number: 2600 },
    { id: 3, text: 'Integrated', number: 2000 },
    { id: 4, text: 'Fully Optimized', number: 1600 },
  ];

  public CountryList = [
    'United States',
    'Aland Islands',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia, Plurinational State Of',
    'Bonaire, Saint Eustatius and Saba',
    'Bosnia and Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cayman Islands',
    'Cape Verde',
    'Central African Republic',
    'Ceuta and Melilla',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos (Keeling) Islands',
    'Colombia',
    'Comoros',
    "Congo, Democratic People's Republic",
    'Congo, Republic of',
    'Cook Islands',
    'Costa Rica',
    "Côte D'Ivoire",
    'Croatia/Hrvatska',
    'Cuba',
    'Curaçao',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands (Malvinas)',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard and McDonald Islands',
    'Holy See (Vatican City State)',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran, Islamic Republic of',
    'Iraq',
    'Ireland',
    'Isle of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Korea, Republic of',
    'Kuwait',
    'Kyrgyzstan',
    "Lao People's Democratic Republic",
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libyan Arab Jamahiriya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macau',
    'Macedonia, The Former Yugoslav Republic Of',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia, Federal State of',
    'Moldova, Republic of',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar (Burma)',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'North Korea',
    'Northern Mariana Islands',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestinian Territories',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn Island',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion Island',
    'Romania',
    'Rwanda',
    'Saint Barthélemy',
    'Saint Helena',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint-Martin',
    'Saint Vincent and Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Sint Maarten',
    'Slovak Republic',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'St. Pierre and Miquelon',
    'Sudan',
    'Suriname',
    'Svalbard and Jan Mayen Islands',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan, Republic of China',
    'Tajikistan',
    'Tanzania, United Republic Of',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks and Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom (GB)',
    'Uruguay',
    'US Minor Outlying Islands',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Viet Nam',
    'Virgin Islands (British)',
    'Virgin Islands (USA)',
    'Wallis and Futuna Islands',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe',
  ];
}

export interface InputValue {
  nbrAdmins: number;
  usableCapacity: number;
  maturity: string;
  maturityValue: number;
  currency: 'CAD' | 'EUR' | 'GBP' | 'USD';

  salary: number;
  pctFTEtime: number;
  tickets: number;
  timeTickets: number;
  pct_planningEval: number;
  pct_monitoring: number;
  pct_applicationOptimization: number;
  pct_securityEomp: number;
  pct_userAccess: number;
  pct_dataProtection: number;
  pct_newInstalls: number;

  TCOSavings: number;
  totalAdminSavings: number;
  pctTCO: number;
  openResult: boolean;
}

export const initialValue: InputValue = {
  nbrAdmins: 2,
  usableCapacity: 100,
  maturity: 'Basic',
  maturityValue: 3500,
  currency: 'USD',

  salary: 163200,
  pctFTEtime: 50,
  tickets: 10,
  timeTickets: 90,

  pct_planningEval: 20,
  pct_monitoring: 15,
  pct_applicationOptimization: 20,
  pct_securityEomp: 10,
  pct_userAccess: 10,
  pct_dataProtection: 15,
  pct_newInstalls: 10,

  TCOSavings: 175799,
  totalAdminSavings: 175799,
  pctTCO: 86,

  openResult: false,
};
